import { FilterValue } from "../Filters/FilterValue";

export const POD_ORDER_TYPE_ID = "7";

export const isPodOrderType = (
  typeId: string | number | null | undefined,
): boolean => String(typeId ?? "") === POD_ORDER_TYPE_ID;

/** Shown when POD projects block classic sourcing / inventory / packing mutations. */
export const POD_PROJECT_OPS_DISABLED_MESSAGE =
  "Not available for POD orders. Use the POD Orders flow (allocate, print outward / inward, shipments) instead.";

export const OrderType: FilterValue[] = [
  // { id: "0", value: "" },
  { id: "1", value: "Normal" },
  { id: "2", value: "Unpaid" },
  { id: "3", value: "Event" },
  { id: "4", value: "Storage" },
  { id: "5", value: "Paid Sample" },
  { id: "6", value: "Hybrid" },
  { id: "7", value: "POD" },
];

export const DEFAULT_PROJECT_REQUEST_ORDER_TYPES: FilterValue[] =
  OrderType.filter((item) => item.id !== POD_ORDER_TYPE_ID);

/** POD stays POD. Every other order type stays off the POD flow. */
export const filterOrderTypesForFlow = (
  options: FilterValue[],
  currentTypeId: string | number | null | undefined,
): FilterValue[] => {
  const current = String(currentTypeId ?? "");
  if (current === POD_ORDER_TYPE_ID) {
    const podOnly = options.filter(
      (item) => String(item.id) === POD_ORDER_TYPE_ID,
    );
    return podOnly.length > 0
      ? podOnly
      : OrderType.filter((item) => item.id === POD_ORDER_TYPE_ID);
  }
  return options.filter((item) => String(item.id) !== POD_ORDER_TYPE_ID);
};

export const parseOrderTypeFilterFromSearch = (
  raw: string | null,
  hasOrderTypeParam: boolean,
): FilterValue[] => {
  if (!hasOrderTypeParam) {
    return DEFAULT_PROJECT_REQUEST_ORDER_TYPES;
  }

  const ids = (raw || "")
    .split(",")
    .map((item) => item.split(":")[0].trim())
    .filter(Boolean);

  return OrderType.filter((item) => ids.includes(String(item.id)));
};
